import { useEffect } from 'react';

export function useJsonLd(json: Record<string, unknown>) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(json);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [json]);
}

export function generateWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '丫丫漫画',
    url: 'https://jxjdxwx.cn/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://jxjdxwx.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '丫丫漫画',
    url: 'https://jxjdxwx.cn/',
    description: '丫丫漫画是一个中文漫画在线阅读平台，提供下拉式翻页阅读体验，免费畅享韩漫、日漫、国漫全集。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'support@jxjdxwx.cn',
      availableLanguage: ['Chinese'],
    },
  };
}

export function generateBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function generateArticleSchema(comic: {
  title: string;
  author: string;
  description: string;
  coverImage: string;
  updatedAt: string;
  url: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: `${comic.title} - 丫丫漫画`,
    author: {
      '@type': 'Person',
      name: comic.author,
    },
    description: comic.description,
    image: comic.coverImage,
    datePublished: comic.updatedAt,
    dateModified: comic.updatedAt,
    url: comic.url,
    publisher: {
      '@type': 'Organization',
      name: '丫丫漫画',
    },
  };
}

export function generateFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}